// This file is auto-generated during deployment - do not edit manually
export const buildInfo = {
  gitHash: '8c6de17', // Short git hash of the current commit
  releaseDate: '2026-09-05', // Date of the release
};
